import "./assets/scss/index.scss";
import "./assets/scss/globals.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import "lazysizes";
import * as OfflinePluginRuntime from "offline-plugin/runtime";
import { DarkLightMode } from "./utils/helper";
import GoogleAnalytics from "./utils/gTag";
import GetSiteVersionNumber from "./utils/webScraper";
import "./pages/header";
import "./pages/footer";
import "./pages/hero";
import "./pages/promo";
import "./pages/about";
import "./pages/blog";
import "./pages/work.ts";
import "./components/G_Maintenance";
import "./components/M_ScrollToTopButton";
import "./components/M_Hero";
import "./components/M_link";
import "./components/M_image";
import "./components/D_Login";
let darkLightModeInstance = null;
function getSharedDarkLightMode() {
    if (!darkLightModeInstance) {
        darkLightModeInstance = DarkLightMode.getInstance();
    }
    return darkLightModeInstance;
}
function registerServiceWorker() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .register("/worker.js")
            .catch((error) => {
            console.error("Service worker registration failed:", error);
        });
    }
}
function registerOfflinePlugin() {
    OfflinePluginRuntime.install({
        onUpdateReady: () => OfflinePluginRuntime.applyUpdate(),
        onUpdated: () => location.reload()
    });
}
class HomePage extends HTMLElement {
    connectedCallback() {
        getSharedDarkLightMode();
        registerServiceWorker();
        registerOfflinePlugin();
        new GoogleAnalytics().trackPage();
        new GetSiteVersionNumber().init();
    }
    disconnectedCallback() {
        if (darkLightModeInstance) {
            DarkLightMode.destroyInstance();
            darkLightModeInstance = null;
        }
    }
}
export default HomePage;
customElements.define("app-main", HomePage);
